<template>
  <div>
    <div v-if="rightsUrl !== ''" class="agree">开通即同意<a :href="rightsUrl">《会员须知》</a></div>
    <p :class="{bigBtn:bigBtn,disable}" class="btn" @click="btnClick">{{ btnText }}</p>
  </div>
</template>

<script>
export default {
  name: 'NormalBtn',
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: ''
    },
    rightsUrl: {
      type: String,
      default: ''
    },
    bigBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    btnClick () {
      if (!this.disable) {
        this.$emit('btnClick')
      }
    }
  }
}
</script>

<style  lang="scss" scoped>
.agree{
  text-align: center;
  font-size: 12px;
  color: #999999;
  padding: 10px 0 5px 0;
  >a{
    color: #0080FE;
  }
}
.disable {
  background: #DDDDDD !important;
  color: #999999 !important;
}
.btn{
  line-height: 40px;
  color: #402200;
  font-weight: 500;
  text-align: center;
  font-size: 16px;
  border-radius: 1px;
  background: linear-gradient(90deg, #EBD2A8 0%, #E9BA66 100%);
  border-radius: 44px;
  width: 100%;
}
  .bigBtn{
    line-height:49px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/NormalBtn.vue